import styled from "styled-components";

export const TextInputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  padding: ${props => props.isExistIcon ? '.8rem 2.8rem .8rem .5rem' : '.8rem 1.6rem .8rem .5rem'};
  border-radius: 10px;
  border: 1px solid #6C8CBF;
  transition: .3s;
  min-width: 350px;
  color: var(--dark-gray-color);

  &::placeholder {
    color: var(--gray-color);
  }

  &:focus {
    outline: none;
    border: 1px solid #4e6a9b;
  }

  &:focus + label {
    top: -11px;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #FDFDFE inset !important;
  }
  
  @media (max-width: 576px) {
    min-width: 280px;
  }

`;

export const TextInputLabel = styled.label`
  color: var(--gray-color);
  background-color: #FDFDFE;
  position: absolute;
  padding: 0 .5rem;
  right: ${props => props.isExistIcon ? '2.3rem' : '1.2rem'};
  top: ${props => props.isActive ? '-11px' : '.8rem'};
  transition: .3s;
  pointer-events: none;
  display: flex;

  span {
    color: #C0CCDD;
    margin-right: .7rem;
    font-size: .9rem;
  }
`;

export const InputIcon = styled.i`
  position: absolute;
  right: .8rem;
  top: 1rem;
`;

/*Check box*/

export const CheckBoxInput = styled.input`
  display: none;

  &:checked + label {
    color: var(--success-color);

    i:before {
      color: var(--success-color);
    }
  }
`;

export const CheckBoxLabel = styled.label`
  font-size: 1.1rem;
  cursor: pointer;
  color: var(--gray-color);
  transition: .2s;
  display: flex;
  align-items: center;

  i:before {
    color: var(--gray-color);
    transition: .2s;
  }

  &:hover {
    color: var(--light-gray-color);

    i:before {
      color: var(--light-gray-color);
    }
  }
  
  @media (max-width: 576px) {
    font-size: .9rem;
  }
`;

export const FileInputLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--sky-blue);
  border-radius: 30px;
  padding: .6rem 3rem;
  color: #FFFFFF;
  cursor: pointer;
  transition: .3s;

  &:hover {
    background-color: #5276a6;
  }
`;

export const UploadedFileLabel = styled.div`
  border: 1px solid var(--sky-blue);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  direction: ltr;
  min-width: 400px;
  max-width: 400px;
  cursor: pointer;

  p {
    max-width: 260px;
  }

  i {
    font-size: 1.3rem;
    vertical-align: middle;
  }
  
  @media (max-width: 992px) {
    width: 100%;
    min-width: unset;
    max-width: 100%;
  }
`;

export const CTimerPickerWrapper = styled.div`
  direction: ltr;
  position: relative;

  label {
    color: var(--gray-color);
  }

  .preview_container {
    padding-right: 0 ;
    left: unset;
    right: 20px;
  }
  
  .time_picker_preview {
    box-shadow: none;
    background-color: transparent;
    border-radius: 10px;
    border: 1px solid var(--sky-blue);
    color: var(--gray-color);
  }

  .picker_container {
    margin: 10px auto 10px;
  }
`;

export const TimePickerIconWrapper = styled.div`
  position: absolute;
  right: 20px;
  bottom: 10px;
  pointer-events: none;
`;

export const SimpleTextInputWrapper = styled.div`
  position: relative;
  
  label {
    color: var(--gray-color);
  }

  input {
    background-color: transparent;
    width: 100%;
    padding: .8rem 2.8rem .8rem .5rem;
    border-radius: 10px;
    border: 1px solid var(--sky-blue);
    transition: .3s;
    color: var(--dark-gray-color);

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px #FDFDFE inset !important;
    }

    &::placeholder {
      color: var(--gray-color);
    }

    &:focus {
      outline: none;
      border: 1px solid #465787;
    }
  }
  
  @media (max-width: 992px) {
    
    ${props => props.inputValue ? {
      label: {
        display: 'none'
      }
    } : {}}
    input::placeholder {
      color: transparent;
    }
    
    label {
      position: absolute;
      right: 52px;
      top: 14px;
      pointer-events: none;
    }
    
  }
`;

export const SimpleTextIconWrapper = styled.div`
  position: absolute;
  top: 48px;
  right: 20px;
  pointer-events: none;

  @media (max-width: 992px) {
    top: 18px;
  }
`;

export const CDatePickerWrapper = styled.div`
  position: relative;
  
  input {
    padding: .8rem 3.3rem .8rem .5rem;
    background-color: transparent;
    border-radius: 10px;
    width: 100%;
    border: 1px solid var(--sky-blue);
    color: var(--gray-color);
  }

  label {
    color: var(--gray-color);
  }
`;

export const DatePickerIconWrapper = styled.div`
  position: absolute;
  right: 20px;
  bottom: 13px;
  pointer-events: none;
`;

export const SelectSearchWrapper = styled.div`
  position: relative;

  label {
    color: var(--gray-color);
  }

  .select-search {
    width: 100%;
  }

  .select-search__input {
    line-height: inherit;
    height: inherit;
    background-color: transparent;
    width: 100%;
    padding: .8rem 2.8rem .8rem .5rem;
    border-radius: 10px;
    border: 1px solid var(--sky-blue);
    transition: .3s;
    color: var(--dark-gray-color);
    box-shadow: none;
  }
  
  @media (max-width: 992px) {

    ${props => !props.inputValue ? {} : {
        label: {
          display: 'none'
        }
    }};
    
    &.rs-select .select-search__input::placeholder {
      color: transparent;
    }
    
    &.rs-select label {
      position: absolute;
      top: 12px;
      right: 48px;
    }
    
    &.rs-hide-label label {
      display: none;
    }
  }

`;

export const IconWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 16px;

  i::before {
    color: var(--sky-blue);
  }
`;

export const CustomTextAreaWrapper = styled.div`

  position: relative;

  label {
    color: var(--gray-color);
    margin-right: .5rem;

    span {
      color: #C0CCDD;
      margin-right: .8rem;
      font-size: .85rem;
    }
  }

  textarea {
    color: var(--dark-gray-color);
    border: 1px solid var(--sky-blue);
    border-radius: 10px;
    resize: none;
    width: 100%;
    padding: 1rem 2.5rem 1rem 1rem;
    transition: .2s;

    &:focus {
      outline: none;
      border: 1px solid #4b6691;
    }
  }
  
  @media (max-width: 992px) {
    label {
      color: transparent;  
    }
    
    label span {
      ${props => props.inputValue ? {
          display: 'none'
      } : {}}
      color: #C0CCDD;
      top: 90px;
      right: 30px;
    }
  }
`;

export const TextAreaIconWrapper = styled.div`
  position: absolute;
  top: 60px;
  right: 16px;
`;
